<template>
    <rkm-form
        v-if="model"
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-input
                    :validations="validations.usuario"
                    label="Usuário"
                    v-model="model.usuario"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    :validations="validations.senha"
                    label="Senha"
                    type="password"
                    v-model="model.senha"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-checkbox
                    :label="false"
                    v-model="model.ativo"
                >
                    Ativo
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

// Others.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                usuario: {
                    required: true,
                    max: 100,
                },
                senha: {
                    required: true,
                    max: 100,
                },
            }
        },
    },
    created() {
        this.repositories = {
            parametrizacao: this.getConectaSusRepository('integracao.bnafar.parametrizacao'),
        }
    },
    data: () => ({
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        create() {
            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(response => this.model = Object.assign(response.data.model))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        store() {
            this.setLoading()

            this.repositories.parametrizacao.store(this.model)
                .then(() => {
                    this.showSaveNotification()
                    this.$emit('saved')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.Form.validate()
                .then(valid => {
                    if (!valid) return

                    this.store()
                })
        },
    },
    mixins: [error, repository],
    mounted() {
        this.create()
    },
}
</script>